import Vue from 'vue';
import Vuex from 'vuex';
import * as RouterPath from '@/classification/RouterPath';

Vue.use(Vuex);

interface State {
  routerPath: any;
  isRefreshed: boolean;
  isDisplayTermsModal: boolean;
  exam: any;
}

export default new Vuex.Store({
  state: {
    routerPath: RouterPath,
    isRefreshed: false,
    isDisplayTermsModal: false,
    exam: null,
  },
  mutations: {
    execRefresh(state: State, val: boolean) {
      state.isRefreshed = val;
    },
    displayTermsModal(state: State, val: boolean) {
      state.isDisplayTermsModal = val;
    },
    saveExamInfo(state: State, exam: any) {
      state.exam = exam;
    },
  },
  actions: {
  },
  modules: {
  },
});
